import Component from "../../Component";
import BaseApi from "./BaseApi";
import { Location } from "../types";

// Define types for better type safety

/**
 * Location API - Handles all location-related operations
 * Extends BaseApi for consistent error handling and authentication
 * Follows Single Responsibility Principle
 */
export default class LocationApi extends BaseApi {
    constructor(component: Component) {
        super(component);
    }

    /**
     * Fetches all available locations
     * @returns Promise<Location[]> Array of all locations
     */
    public async fetchAllLocations(): Promise<Location[]> {
        return this.fetchWithAuth<Location[]>("/locations");
    }

    /**
     * Fetches floors by location ID
     * @param locationId Location ID to filter floors by
     * @returns Promise<any[]> Array of floors for the specified location
     */
    public async fetchFloorsByLocation(locationId: string): Promise<any[]> {
        // Get all floorplans and filter by location
        const allFloorplans = await this.fetchWithAuth<any[]>("/floorplan");

        // Filter floorplans by location ID
        const filteredFloors = allFloorplans.filter(
            (floor: any) => floor.location && floor.location.id === locationId
        );

        return filteredFloors;
    }
}
